import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import {
  CustomSelect,
  TextInput,
} from "components/Input/Index.js";
import CreateButton from "components/CustomButtons/CreateButton.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { getArchitecture } from "services/ConfigServices";
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function AddGroupDialog(props) {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const currentusertype = localStorage.getItem('userType');
  const [name, setName] = useState("");
  const [typestr, setTypestr] = useState("");
  const [type, setType] = useState("");
  const [subtype, setSubtype] = useState("");

  const [disabled, setDisabled] = useState(true);
  const {parentGroup} = props;

  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleTypeChange = (e) => {
    let typetarget = e.target.value;
    let type = 0;
    let subtype = 0;
    setTypestr(typetarget);
    if (typetarget === "0_0") {
      type = 0;
      subtype = 0;
    }
    else if (typetarget === "0_1") {
      type = 0;
      subtype = 1;
    }
    else if (typetarget === "0_2") {
      type = 0;
      subtype = 2;
    }
    else if (typetarget === "1_0") {
      type = 1;
      subtype = 0;
    }
    else if (typetarget === "2_0") {
      type = 2;
      subtype = 0;
    }
    else if (typetarget === "2_1") {
      type = 2;
      subtype = 1;
    }
    else if (typetarget === "3_0") {
      type = 3;
      subtype = 0;
    }
    else if (typetarget === "4_0") {
      type = 4;
      subtype = 0;
    }
    setType(type);
    setSubtype(subtype);
  };

  useEffect(() => {
    if (!name || !typestr || (name && !name.match(textPattern)))
      setDisabled(true);
    else
      setDisabled(false);
  });

  const textPattern = new RegExp(/^[a-zA-Z0-9éêèàçùô()'\-_\ ]*$/);

  const handleSubmit = async (event) => {
    axios
      .post(
        getArchitecture(parentGroup || chartIdGroup),
        { name: name, type: type, subtype: subtype },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          let newgroupid = "" + res.data.newgroupid;
          NotificationManager.success("Groupe ajouté");
          props.closeModal();
          props.handleSubmitSuccess(newgroupid, name);
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };


  const typeData = [
    { name: "Commune", id: "0_0" },
    { name: "EPCI", id: "0_1" },
    { name: "Groupe", id: "0_2" },
    { name: "Site", id: "1_0" },
    { name: "Bâtiment", id: "2_0" },
    { name: "Equipement urbain", id: "2_1" },
    { name: "Zone", id: "3_0" },
  ];

  const typeDataadmin = [
    { name: "Commune", id: "0_0" },
    { name: "EPCI", id: "0_1" },
    { name: "Groupe", id: "0_2" },
    { name: "Site", id: "1_0" },
    { name: "Bâtiment", id: "2_0" },
    { name: "Equipement urbain", id: "2_1" },
    { name: "Zone", id: "3_0" },
    { name: "Compte client", id: "4_0" },
  ];

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={"Nom"}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={"Type de groupe"}
                selectValue={typestr}
                handleSelectValueChange={handleTypeChange}
                data={currentusertype == 1 ? typeDataadmin : typeData}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <CreateButton buttonDisabled={disabled} handleSubmit={handleSubmit} />
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}></GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default AddGroupDialog;
